import { FormikValues, useFormikContext } from "formik";

import { HStack, PinInput, PinInputField } from "@chakra-ui/react";

interface OTPFieldProps {
  name: string;
  fieldLength: number;
}

function OTPField<Value extends FormikValues>({
  name,
  fieldLength,
  ...props
}: OTPFieldProps) {
  const { handleChange, values } = useFormikContext<Value>();

  return (
    <HStack mt={10} mb={10} {...props}>
      <PinInput
        id={name}
        size="lg"
        type="number"
        onChange={handleChange(name)}
        value={values.name}
      >
        {Array.from(Array(fieldLength).keys()).map((_, index) => (
          <PinInputField key={index} />
        ))}
      </PinInput>
    </HStack>
  );
}

export default OTPField;
